/**
 * Kopfleiste von Wizard-Schritt 2: Abschnittstitel links, Aktionen fuer ALLE
 * Channels rechts. "Nur leere Felder" ist bewusst deaktiviert — dafuer fehlt
 * die Datenbasis (welche Felder je Produkt×Channel leer sind).
 */

import { useTranslation } from 'react-i18next'

interface StepChannelFieldsToolbarProps {
  title: string
  sourceChannelLabel: string | null
  onSelectAll: () => void
  onCopyFromFirst: () => void
}

const ACTION_CLASS =
  'rounded-md border border-neutral-300 px-3 py-1.5 text-sm text-neutral-700 hover:border-primary-500 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-50 dark:border-neutral-700 dark:text-neutral-300'

export function StepChannelFieldsToolbar({
  title,
  sourceChannelLabel,
  onSelectAll,
  onCopyFromFirst,
}: StepChannelFieldsToolbarProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h3 className="text-2xs font-medium uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
        {title}
      </h3>

      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-neutral-500 dark:text-neutral-400">
          {t('channelContent.wizard.forAllChannels')}
        </span>
        <button
          type="button"
          id="text-bulk-wizard-all-fields"
          onClick={onSelectAll}
          className={ACTION_CLASS}
        >
          {t('channelContent.wizard.allFields')}
        </button>
        <button
          type="button"
          id="text-bulk-wizard-only-empty-fields"
          disabled
          title={t('channelContent.wizard.onlyEmptyFieldsUnavailable')}
          className={ACTION_CLASS}
        >
          {t('channelContent.wizard.onlyEmptyFields')}
        </button>
        {sourceChannelLabel && (
          <button
            type="button"
            id="text-bulk-wizard-copy-selection"
            onClick={onCopyFromFirst}
            className={ACTION_CLASS}
          >
            {t('channelContent.wizard.copySelectionFrom', { channel: sourceChannelLabel })}
          </button>
        )}
      </div>
    </div>
  )
}
